import React, { type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';
import Icon from '@atlaskit/icon/glyph/cross';
import Tooltip from '@atlaskit/tooltip';
import { defineMessages, useIntlV2 as useIntl } from '@atlassian/jira-intl';

// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */

const messages = defineMessages({
	label: {
		id: 'issue.label-for-modal-close-button',
		defaultMessage: 'Close',
		description: '',
	},
});

type Props = {
	onClose: (e: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
};

export const ModalActionsCloseButton = ({ onClose }: Props) => {
	const intlCloseText = useIntl().formatMessage(messages.label);
	const closeIcon = <Icon label="" size="medium" />;

	return (
		<div>
			<Tooltip content={intlCloseText} position="top">
				<Button
					aria-label={intlCloseText}
					appearance="subtle"
					spacing="default"
					iconBefore={closeIcon}
					onClick={onClose}
					interactionName="auto-generated.jira-issue-view-foundation.button"
				/>
			</Tooltip>
		</div>
	);
};

export default ModalActionsCloseButton;
